import { Button, Icon, Menu, MenuItem, TextField } from '@mui/material'
import React from 'react'

import SingleChoice from './single-choice'

export type SearchSelectOption = { label: string; value: string }

export type SearchSelectFilterProps = {
  anyLabel?: string
  disabled?: boolean
  label: string
  menuMaxHeight?: number
  name: string
  options: SearchSelectOption[]
  searchPlaceholder?: string
  showAny?: boolean
  value?: string
  onChange: (value?: string) => void
}

const SearchSelectFilter: React.FC<SearchSelectFilterProps> = ({
  anyLabel = 'Any',
  disabled,
  label,
  menuMaxHeight = 300,
  name,
  options,
  searchPlaceholder = 'Search',
  showAny = true,
  value,
  onChange,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement>()
  const [search, setSearch] = React.useState('')

  const filtered = React.useMemo(
    () => options.filter((o) => o.label.toLowerCase().includes(search.trim().toLowerCase())),
    [options, search],
  )

  const choiceOptions = React.useMemo(() => {
    const base = filtered.map((o) => ({ label: o.label, value: o.value }))
    return showAny ? [{ label: anyLabel, value: '' }, ...base] : base
  }, [filtered, showAny, anyLabel])

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<Icon>filter_list</Icon>}
        endIcon={<Icon>arrow_drop_down</Icon>}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        disabled={disabled}
        sx={{ textTransform: 'none' }}
      >
        {label}
      </Button>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(undefined)}>
        <MenuItem>
          <TextField
            size="small"
            fullWidth
            placeholder={searchPlaceholder}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
        </MenuItem>
        <div style={{ maxHeight: menuMaxHeight, overflowY: 'auto' }}>
          <SingleChoice
            name={name}
            options={choiceOptions}
            value={value || ''}
            onChange={(v) => {
              const newVal = v || undefined
              onChange(newVal)
              setAnchorEl(undefined)
            }}
          />
        </div>
      </Menu>
    </>
  )
}

export default SearchSelectFilter
